// extracted by mini-css-extract-plugin
export default {"tasks":"MM-z","task":"NM-z","svg":"OM-z","text":"PM-z"};